<template>
  <a
      href="javascript: void(0);"
      class="badge m-1 align-items-center p-1"
      style="cursor:default !important;"
      :class="`badge-${variant} font-size-${badgeSize} ${flex ? 'd-flex' : ''}`"
  >
      <slot/>
  </a>
</template>

<script>
export default {
  name: "Badge",
  props: {
    size: {
      Default: 'md',
      type: String
    },
    variant: {
      Default: 'primary',
      type: String
    },
    flex: {
      Default: false
    },
    color: {
      Default: null
    }
  },
  data() {
    return {
      sizeOptions: {
        sm: '8',
        md: '12',
        lg: '13',
        xl: '15'
      }
    }
  },
  computed: {
    badgeSize() {
      return this.sizeOptions[this.size]
    },
  }
}
</script>

<style scoped>

</style>